<template>
  <div class="login">

    <form class="login">

      <byjove-logo :appsettings="appsettings"
                   style="text-align: center;">
      </byjove-logo>

      <b-field label="Email">
        <b-input v-model.trim="username" />
      </b-field>

      <b-field label="Password">
        <b-input v-model="password" type="password" />
      </b-field>

      <div v-if="loginError" style="color: red;">
        {{ loginError }}
      </div>

      <div class="buttons">
        <b-button type="is-primary"
                  @click="attemptLogin()"
                  :disabled="loginFormDisabled"
                  expanded>
          Login
        </b-button>
        <b-button type="is-primary"
                  @click="showForgotPassword()"
                  expanded>
          Forgot your password?
        </b-button>
      </div>

      <br />
      <p class="block">
        If you&apos;re having trouble logging in, please contact the
        member administrator at
        <a href="mailto:membership@sac.coop">membership@sac.coop</a>
        or 916-732-3148
      </p>
    </form>

    <b-modal has-modal-card
             :active.sync="showForgotPasswordDialog">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Reset Password</p>
        </header>

        <section class="modal-card-body">
          <b-field label="Email Address">
            <b-input v-model.trim="forgotPasswordEmail"
                     :disabled="resetSent">
            </b-input>
          </b-field>
          <div v-if="resetSent">
            <b-notification type="is-success"
                            :closable="false">
              {{ resetSuccessMessage }}
            </b-notification>
            <b-notification type="is-warning"
                            :closable="false">
              If you don&apos;t receive a reset email, please check your spam folder.
            </b-notification>
          </div>
        </section>

        <footer class="modal-card-foot">
          <b-button v-if="!resetSent"
                    type="is-primary"
                    @click="submitForgotPassword()"
                    :disabled="forgotPasswordDisabled">
            Submit
          </b-button>
          <b-button v-if="resetSent"
                    @click="showForgotPasswordDialog = false">
            Close
          </b-button>
        </footer>
      </div>
    </b-modal>

  </div>
</template>

<script>
import appsettings from '@/appsettings'
import {ByjoveLogo} from 'byjove'

export default {
    name: 'Login',
    components: {
        ByjoveLogo,
    },
    data: function () {
        return {
            appsettings: appsettings,
            username: null,
            password: null,
            loginError: null,
            showForgotPasswordDialog: false,
            forgotPasswordEmail: null,
            resetSent: false,
            resetSuccessMessage: null,
        }
    },
    computed: {
        loginFormDisabled: function() {
            if (!this.username) {
                return true
            } else if (!this.password) {
                return true
            }
            return false
        },
        forgotPasswordDisabled: function() {
            if (!this.forgotPasswordEmail) {
                return true
            }
            return false
        },
    },
    created: function() {
        this.checkUser()
    },
    watch: {
        '$store.state.session_established': 'checkUser',
        '$store.state.settings_established': 'checkUser',
    },
    methods: {

        checkUser() {
            // send logged-in users to "home" instead
            if (this.$store.state.session_established && this.$store.state.user.uuid) {
                if (this.$store.state.settings_established) {
                    if (this.$store.state.expose_home) {
                        this.$router.push('/')
                    } else {
                        this.$router.push('/benefits')
                    }
                }
            }
        },

        attemptLogin: function() {
            this.loginError = null;
            var creds = {
                username: this.username,
                password: this.password
            };

            this.$http.post('/api/login', creds).then(response => {
                if (response.data.error) {
                    this.loginError = response.data.error;
                } else {
                    // let byjove do login proper
                    this.$loginUser(response.data.user)
                    // after user logs in, show "home" page
                    if (this.$store.state.expose_home) {
                        this.$router.push('/')
                    } else {
                        this.$router.push('/benefits')
                    }
                }
            })

        },

        showForgotPassword: function() {
            this.forgotPasswordEmail = null
            this.resetSent = false
            this.showForgotPasswordDialog = true
        },

        submitForgotPassword: function() {
            let params = {
                'email': this.forgotPasswordEmail,
            }

            this.$http.post('/api/reset-password', params).then(response => {
                // TODO: some of this seems a bit convoluted, but for now we
                // must continue to match the older pseudo-API logic
                if (response.data.ok) {
                    if (response.data.warning) {
                        this.showForgotPasswordDialog = false
                        this.$buefy.toast.open({
                            message: response.data.warning,
                            type: 'is-info',
                            duration: 10000, // 10 seconds
                        })
                    } else {
                        this.resetSent = true
                        this.resetSuccessMessage = response.data.ok
                    }
                }

                if (response.data.error) {
                    this.$buefy.toast.open({
                        message: response.data.error,
                        type: 'is-danger',
                        duration: 10000, // 10 seconds
                    })
                }
            }, response => {
                this.$buefy.toast.open({
                    message: "something went wrong!",
                    type: 'is-danger',
                })
            })
        },
    }
}
</script>

<style scoped>
form.login {
    max-width: 25rem;
    margin: 2rem auto;
}
</style>
